import { render, staticRenderFns } from "./hint.vue?vue&type=template&id=6828f8d7&lang=pug&"
import script from "./hint.vue?vue&type=script&setup=true&lang=js&"
export * from "./hint.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./hint.vue?vue&type=style&index=0&id=6828f8d7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports